<template>
    <div>
        <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                    >{{ $t('landingPage.settingApplicationRule.titleBlock') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-10">
                    {{ dataForm.block_application_rule?.title_block ?? '' }}
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationRule.background') }}</label>
                <div class="col-sm-10">
                    <div v-if="dataForm.block_application_rule.background_image?.path" style="width: 200px; height: 200px" class="position-relative">
                        <b-img
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.block_application_rule.background_image?.path"
                            :alt="dataForm.block_application_rule.background_image.origin_name"
                            style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                        ></b-img>
                    </div>
                    <div class="my-3">
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataForm.block_application_rule.background_color"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                            :disabled="true"
                        />
                    </div>
                    <div>
                        <InputCheckBox
                            :model.sync="dataForm.block_application_rule.is_repeat"
                            :id="`check-repeat-background-app_rule`"
                            :value="dataForm.block_application_rule.is_repeat"
                            :label="`repeat`"
                            :disabled="true"
                        />
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.style') }} </label>
                <div class="col-sm-10">
                    <div style="width: 100px; height: 80px">
                        <img
                            class="w-100 h-100"
                            style="object-fit: cover"
                            :src="dataForm.block_application_rule.style?.image_preview"
                            :alt="dataForm.block_application_rule.style?.image_preview"
                        />
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationRule.detail') }} </label>
                <div class="col-sm-10">
                    <div class="body__preview">
                        <div
                            class="block__application--rule"
                            :style="`background-color: ${dataForm.block_application_rule.background_color ?? ''};
                                    background-image: url(${dataForm.block_application_rule.background_image?.path ?? ''});
                                    background-repeat: ${dataForm.block_application_rule.is_repeat ? 'repeat' : 'no-repeat'};
                                    min-height: 300px;
                                    overflow: hidden;
                                    background-blend-mode: multiply;`"
                        >
                            <div :class="`box--rule__${dataForm.block_application_rule.style?.id}`">
                                <h2
                                    v-if="STYLE_SHOW_TITLE.includes(dataForm.block_application_rule.style?.id)"
                                    class="title-common"
                                    :style="`background: ${dataForm.block_application_rule.background_title ?? ''};
                                            color:  ${dataForm.block_application_rule.color_title ?? ''};
                                            font-size: ${dataForm.block_application_rule.size_title}px;`"
                                >
                                    <span>{{ dataForm.block_application_rule.title_block }}</span>
                                </h2>
                                <div v-else class="title-common">
                                    <h2
                                        class="title-eng"
                                        :style="`background: ${dataForm.block_application_rule.background_title ?? ''};
                                                color:  ${dataForm.block_application_rule.color_title ?? ''};
                                                font-size: ${dataForm.block_application_rule.size_title}px;`"
                                    >
                                        <span>{{ dataForm.block_application_rule.title_block }}</span>
                                    </h2>
                                    <!-- <h2 class="title-jp"></h2> -->
                                </div>
                                <div class="content-rule" v-html="dataForm.block_application_rule?.html_content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputText, InputCheckBox } from '@/components/Input';
import { STYLE_SHOW_TITLE } from '../../../constants';

export default {
    name: 'SettingApplicationRule',
    components: {
        InputText,
        InputCheckBox
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE
        };
    },

    methods: {},
    watch: {},
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
